import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { auth, queryProgressFlags } from './data'
import { getNextStepUrl } from '@/util/route'

export default function Entry() {
  const navigate = useNavigate()
  useEffect(() => {
    async function loginAndRedirect() {
      await auth()
      navigate(getNextStepUrl(await queryProgressFlags()) || '/')
    }
    loginAndRedirect()
  }, [navigate])
  return undefined
}
